import { Component, computed, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { mensagemDeErro } from '../../core/utils/erro-mensagem.util';
import { ThemeService } from '../../core/theme/theme.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly tema = inject(ThemeService);
  readonly rotuloTema = computed(() => `Tema: ${this.tema.preferencia()}`);
  readonly temaEscuro = computed(() => this.tema.efetivo() === 'escuro');
  readonly carregando = signal(false);
  readonly erro = signal<string | null>(null);

  readonly form = this.fb.nonNullable.group({
    nomeUsuario: ['', [Validators.required]],
    senha: ['', [Validators.required]],
  });

  entrar(): void {
    if (this.carregando()) {
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.erro.set(null);
    this.carregando.set(true);
    this.auth.login(this.form.getRawValue()).subscribe({
      next: () => {
        this.carregando.set(false);
        void this.router.navigate(['/home']);
      },
      error: (e: unknown) => {
        this.carregando.set(false);
        this.erro.set(mensagemDeErro(e, 'login'));
      },
    });
  }
}
